import { ElementRef, EventEmitter, SimpleChanges } from '@angular/core';
import scrollIntoView from 'scroll-into-view-if-needed';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
const _c0 = ["categoryList"];
function CategoryListComponent_div_2_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 6);
} if (rf & 2) {
    const category_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("textContent", "(" + ctx_r2.categoryCounts[category_r2] + ")");
} }
function CategoryListComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4);
    i0.ɵɵlistener("click", function CategoryListComponent_div_2_Template_div_click_1_listener() { const category_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.selectCategory(category_r2)); });
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, CategoryListComponent_div_2_span_3_Template, 1, 1, "span", 5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const category_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("selected", ctx_r2.selectedCategory === category_r2);
    i0.ɵɵattribute("data-scroll-target", category_r2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", category_r2, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !!ctx_r2.categoryCounts && ctx_r2.categoryCounts[category_r2]);
} }
/**
 * Category List Component
 *
 * Used to display the list of security list categories within the security list selector modals.
 *
 * Input Properties:
 *  categories: array of strings that are the names of each category to display.
 *  categoryCounts: object containing the count of selected lists for each category
 *  selectedCategory: string that is the currently selected category
 *
 * Output Properties:
 *  categoryChangeHandler: emits the newly selected category whenever the selected category changes
 *
 */
export class CategoryListComponent {
    constructor() {
        this.categories = [];
        this.categoryCounts = {};
        this.selectedCategory = '';
        this.categoryChangeHandler = new EventEmitter();
    }
    ngOnChanges(changes) {
        if (changes?.selectedCategory?.currentValue) {
            this.selectedCategory = changes.selectedCategory.currentValue;
            // If the selected category changes then scroll so the new selected category is in view
            this.scrollToSelected();
        }
    }
    scrollToSelected() {
        const $toScroll = this.$categoryListElement?.nativeElement?.querySelector?.(`[data-scroll-target="${this.selectedCategory}"]`);
        if ($toScroll) {
            scrollIntoView($toScroll, {
                block: 'center',
                // do not scroll beyond the modal
                boundary: (parent) => !parent.classList.contains('modal'),
                scrollMode: 'if-needed',
            });
        }
    }
    selectCategory(newCategory) {
        this.selectedCategory = newCategory;
        this.categoryChangeHandler.emit(this.selectedCategory);
    }
}
CategoryListComponent.ɵfac = function CategoryListComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CategoryListComponent)(); };
CategoryListComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CategoryListComponent, selectors: [["ycn-category-list"]], viewQuery: function CategoryListComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.$categoryListElement = _t.first);
    } }, inputs: { categories: "categories", categoryCounts: "categoryCounts", selectedCategory: "selectedCategory" }, outputs: { categoryChangeHandler: "categoryChangeHandler" }, standalone: false, features: [i0.ɵɵNgOnChangesFeature], decls: 3, vars: 1, consts: [["categoryList", ""], [1, "linked-list-body", "user-select-none"], ["class", "linked-list-item", 3, "selected", 4, "ngFor", "ngForOf"], [1, "linked-list-item"], [1, "linked-list-item-header", 3, "click"], [3, "textContent", 4, "ngIf"], [3, "textContent"]], template: function CategoryListComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 1, 0);
        i0.ɵɵtemplate(2, CategoryListComponent_div_2_Template, 4, 5, "div", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.categories);
    } }, dependencies: [i1.NgForOf, i1.NgIf], encapsulation: 2 });
